module.exports = __webpack_public_path__ + "static/media/chrysochraon_dispar_007_APA.5de1c408.mp3";